import { useState } from "react";
import { FileText, BookOpen, Tags, Instagram, LayoutTemplate } from "lucide-react";
import { PageVisibilityToggle } from "@/components/ui/PageVisibilityToggle";
import { BlogPostManager } from "@/components/BlogPostManager";
import { BlogCategoryManager } from "@/components/BlogCategoryManager";
import { BlogPageManager } from "@/components/BlogPageManager";
import { NewsletterManager } from "@/components/NewsletterManager";
import { BlogTemplateManager } from "@/components/BlogTemplateManager";

const TABS = [
  { id: "posts",      label: "Posts",       icon: FileText },
  { id: "templates",  label: "Templates",   icon: LayoutTemplate },
  { id: "categorias", label: "Categorias",  icon: Tags },
  { id: "cabecalho",  label: "Cabeçalho",   icon: BookOpen },
  { id: "instagram",  label: "Instagram",   icon: Instagram },
] as const;

type TabId = typeof TABS[number]["id"];

export function BlogAdminManager() {
  const [tab, setTab] = useState<TabId>("posts");

  return (
    <div className="space-y-5">
      <PageVisibilityToggle pageKey="page_blog_visible" label="Página do Blog" />

      <div className="flex gap-1 border-b border-gray-100 pb-0 flex-wrap">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
              tab === id
                ? "border-brand-primary text-brand-primary"
                : "border-transparent text-gray-400 hover:text-gray-700"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </button>
        ))}
      </div>

      {tab === "posts"      && <BlogPostManager />}
      {tab === "templates"  && <BlogTemplateManager />}
      {tab === "categorias" && <BlogCategoryManager />}
      {tab === "cabecalho"  && <BlogPageManager />}
      {tab === "instagram"  && <NewsletterManager />}
    </div>
  );
}
